export const INIT_SIGN_UP_INFO = {
    companyname: '',
    postalcode: '',
    companyaddress: '',
    phonenumber: '',
    industries: '',
    representername: '',
    contractrepresentativename1: '',
    contractrepresentativeno1: '',
    contractrepresentativeemail1: '',
    contractplan: '', // select
    emrgncystop: '0',
    terminated: '0',
    schemaurl: 'c_company',
    blobstoragecontainer: 'client-c-container',
    clientthememapid: '', // select
    is_trial: false
}

export const MAX_LENGTH = { min: 50, mid: 60, max: 100, max2: 200 }

export const getPlanSelectList = (t) => [
    {
        code: '0',
        content: t(`signUpClient.contractPlanList.basic`)
    },
    {
        code: '1',
        content: t(`signUpClient.contractPlanList.advanced`)
    },
    {
        code: '2',
        content: t(`signUpClient.contractPlanList.managed`)
    }
]
